import {MutationTree} from 'vuex';
import {ProductTourState} from '@/brief-hub/store/modules/product-tour/types';

export enum MutationsType {
    SET_PRODUCT_TOUR_CHATBOX_MY_PROJECTS_ACKNOWLEDGEMENT = 'setChatboxMyProjectsProductTourAcknowledgement',
    SET_PRODUCT_TOUR_CHATBOX_PROJECT_VIEW_ACKNOWLEDGEMENT = 'setChatboxProjectViewProductTourAcknowledgement',
}

export const mutations: MutationTree<ProductTourState> = {
    [MutationsType.SET_PRODUCT_TOUR_CHATBOX_MY_PROJECTS_ACKNOWLEDGEMENT]: (state): void => {
        state.myProjects = true;
    },
    [MutationsType.SET_PRODUCT_TOUR_CHATBOX_PROJECT_VIEW_ACKNOWLEDGEMENT]: (state): void => {
        state.projectView = true;
    },
};
